<template>
  <div id="error" class="d-flex flex-column justify-content-center align-items-center">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({})
}
</script>

<style lang="scss" scoped>
#error {
  width: 100vw;
  height: 100vh;

  background-image: url(~@/assets/road-in-the-fog.jpg);
  background-size: cover;
}
</style>
